"use strict";

var _jsxRuntime = require("react/jsx-runtime");
module.exports = ({
  title,
  titleId,
  size,
  color,
  ...props
}) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
  ...props,
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  height: size,
  width: size,
  fill: color,
  role: title ? 'img' : undefined,
  "aria-hidden": !title,
  "aria-labelledby": titleId,
  children: [title ? /*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
    id: titleId,
    children: title
  }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "m3.097 20.035.292-6.053a.71.71 0 0 1 .693-.675.626.626 0 0 1 .627.67l-.214 4.43 5.672-5.528c.27-.263.689-.264.934-.003.245.262.224.688-.046.951l-5.673 5.528 4.346-.015a.627.627 0 0 1 .627.67.71.71 0 0 1-.692.675l-5.939.02a.626.626 0 0 1-.627-.67Zm17.806-16.07-.293 6.054a.71.71 0 0 1-.693.675.626.626 0 0 1-.627-.67l.215-4.43-5.675 5.529c-.27.264-.688.265-.933.003-.245-.261-.225-.687.046-.951l5.674-5.53-4.346.016a.626.626 0 0 1-.628-.67.71.71 0 0 1 .693-.675l5.94-.02a.626.626 0 0 1 .627.67Z"
  })]
});